// i18n GS-Hub — SPA (I18N_STANDARDS §8, wiring 4 fichiers calque pilote ug).
// Initialise i18next via @gs/i18n (namespace 'hub' + 'common' partage au runtime).
// Importe par main.tsx AVANT le render React.
import { initI18n } from '@gs/i18n';

import hubFr from './locales/hub.fr.json';
import hubEn from './locales/hub.en.json';

const i18n = initI18n({
  appNamespace: 'hub',
  resources: {
    fr: { hub: hubFr },
    en: { hub: hubEn },
  },
});

export default i18n;
export { useTranslation, Trans, setLocale, SUPPORTED_LOCALES } from '@gs/i18n';
export type { SupportedLocale } from '@gs/i18n';
